'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localStorage = require('./localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

var _sessionStorage = require('./sessionStorage');

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file 封装localStorage和sessionStorage，及相关存储key值
 */

exports.default = {
  keys: {
    // 系统语言
    lang: 'APP_LANG',
    // app版本号，用来验证是否第一次打开app
    version: 'APP_VERSION',
    title: 'VIP_TITLE',
    // 是否登录
    login: 'LOGIN',
    loginName: 'LOGIN_NAME',
    token: 'X-AUTH-TOKEN',
    vipName: 'VIP_NAME',
    user: 'VIP_USER',
    orderInfo: 'ORDER_INFO',
    backPage: 'VIP_BACK_PAGE',
    sysInfo: 'VIP_SYS_INFO',
    topTabs: 'VIP_TOP_TABS'
  },
  localStorage: _localStorage2.default,
  sessionStorage: _sessionStorage2.default
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/store/index.js
// module id = 81
// module chunks = 14